import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { StylesProvider } from "@material-ui/core/styles";
import SidebarContextProvider from "./context/SidebarContext";
import MenuStoreContextProvider from "./context/MenuStoreContext";

const AppProviders = ({ store, persistor, children }) => (
  <MenuStoreContextProvider>
    <SidebarContextProvider>
      <Provider store={store}>
        <PersistGate loading={<div>...</div>} persistor={persistor}>
          <StylesProvider injectFirst>{children}</StylesProvider>
        </PersistGate>
      </Provider>
    </SidebarContextProvider>
  </MenuStoreContextProvider>
);

export default AppProviders;
